module.exports = __webpack_public_path__ + "b7e0fd6739eddb041084a35f23544955.png";